$(document).on("click", ".csm_addnote_wrap", function (e) {
  // prevent firing if click is inside textarea itself
  if (!$(e.target).is("textarea.cart_page_note")) {
    $(this).find("textarea.cart_page_note").stop().slideToggle();
  }
});

function cartPageUpdate() {
  console.log("function called---");
  var url = window.location.href;
  fetch(url)
   .then(response => response.text())
   .then(html => {
    console.log("function called---then2---");
    var parser = new DOMParser();
    var doc = parser.parseFromString(html, 'text/html');
    if (doc.querySelector('.csm-cart-page .cart_d_offer') != null) {
     var mainSectionContent = doc.querySelector('.csm-cart-page .cart_d_offer').innerHTML;
     document.querySelector('.csm-cart-page .cart_d_offer').innerHTML = mainSectionContent;
    }
    if (doc.querySelector('.csm-cart-page .tags_accordion_checkout_wrap') != null) {
     var mainSectionContent = doc.querySelector('.csm-cart-page .tags_accordion_checkout_wrap').innerHTML;
     document.querySelector('.csm-cart-page .tags_accordion_checkout_wrap').innerHTML = mainSectionContent;
    }
    setTimeout(initCartDropdowns, 100);
   })
   .catch(error => {
    console.error('Error fetching collection main section:', error);
   });
 }


 function initCartDropdowns() {
  // Luggage tag
  $(".luggage_tag .prod_title").off("click").on("click", function () {
    $(".luggage_tag .prod_title").toggleClass("active");
    $(".drop_down_cont").slideToggle("slow");
  });

  // Cart embroidery toggle main
  $(".cart_embroidery .prod_title").off("click").on("click", function () {
    $(".cart_embroidery .prod_title").toggleClass("active");
    $(".cart_embroidery .drop_down_cont2").slideToggle("slow");
    $(".cart_embroidery .embro_drop_down").slideUp("slow");
    setTimeout(() => {
      document
        .querySelector(".overaroundforscroll_second")
        ?.dispatchEvent(new MouseEvent("click", { bubbles: false }));
    }, 300);
  });

  // Cart embossing toggle main
  $(".cart_embossing .prod_title").off("click").on("click", function () {
    $(".cart_embossing .prod_title").toggleClass("active");
    $(".cart_embossing .drop_down_cont2").slideToggle("slow");
    $(".cart_embossing .embro_drop_down").slideUp("slow");
    setTimeout(() => {
      document
        .querySelector(".overaroundforscroll_second")
        ?.dispatchEvent(new MouseEvent("click", { bubbles: false }));
    }, 300);
  });

  // Embroidery active sub
  $(".cart_embroidery .active_prod").off("click").on("click", function () {
    $(".cart_embroidery .embro_drop_down").slideToggle("slow");
    $(".cart_embroidery .crt_sans_content").toggleClass("active");
  });

  // Embossing active sub
  $(".cart_embossing .active_prod").off("click").on("click", function () {
    $(".cart_embossing .embro_drop_down").slideToggle("slow");
    $(".cart_embossing .crt_sans_content").toggleClass("active");
  });

  let timerGifrt = null;
  $('[name="attributes[Gift Wrapping]"]').click(function () {
    function debounce() {
      if (timerGifrt) {
        clearTimeout(timerGifrt);
      }
      timerGifrt = setTimeout(() => addGiftProduct(), 300);
    }
    debounce();
  });

  async function addGiftProduct() {
    const isGiftAdd = $('[name="attributes[Gift Wrapping]"]')[0].checked;
    const hasAlready = $('.gift_checkmark').data().hasGiftAdded;
    if (isGiftAdd && !hasAlready) {
      $('.gift_checkmark').attr('disabled','');
      
      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        dataType: "json",
        data: {
          quantity: 1,
          id: 40105492774947,
          sections: "cart-drawer",
        },
        success: function (response) {
          // console.log("Gift", response);
          const html = new DOMParser().parseFromString(
            response.sections["cart-drawer"],
            "text/html"
          );
          document.querySelector("cart-quantity").updateHTML(html);
          document.dispatchEvent(new CustomEvent('theme:cartchanged'));
          // updateCartPageUI();
        },
        error: function (error) {
          console.log("Gift not added");
        },
      });
      $('.gift_checkmark').removeAttr('disabled');
    }
    else{
      $('.gift_checkmark').attr('disabled','');
      $.ajax({
        type: "POST",
        url: "/cart/change.js",
        dataType: "json",
        // signal: abortController.signal,
        data: {
          quantity: 0,
          id: 40105492774947,
          sections: "cart-drawer",
        },
        success: function (response) {
          // console.log("Gift", response);
          const html = new DOMParser().parseFromString(
            response.sections["cart-drawer"],
            "text/html"
          );
          document.querySelector("cart-quantity").updateHTML(html);
          document.dispatchEvent(new CustomEvent('theme:cartchanged'));
          // updateCartPageUI();
        },
        error: function (error) {
          console.log("Gift not added");
        },
      });
      $('.gift_checkmark').removeAttr('disabled');
    }
  }

  $(".add_comp_prod").click(async function () {
    // console.log($(this).data().productHandle);
    let addedData;
    if ($(this).data().productHandle == "bag-tag-brown") {
      let prodId = parseInt($('input[name="tag_product_id"]:checked').val());
      let isAddEmbos = $('input[name="embossing"]:checked').val();
      // let custEmbbos = $('[name="custom_embos_inupt"]').val();
      let custEmbbos = $('[name="custom_embos_inupt"]').val().toUpperCase();

      
      if (isAddEmbos == "yes" && custEmbbos.length < 1) {
        $(".error_custom_embosss").removeClass("hidden");
        return;
      }
      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        dataType: "json",
        data: {
          quantity: 1,
          id: prodId,
          sections: "cart-drawer",
        },
        success: function (response) {
          if (isAddEmbos == "yes") {
            let embo_id = parseInt(
              $('[name="embossing"]:checked').data().productId
            );
            $.ajax({
              type: "POST",
              url: "/cart/add.js",
              dataType: "json",
              data: {
                quantity: 1,
                id: embo_id,
                properties: {
                  "Custom Embossing Text": `${custEmbbos}`,
                  "Product Name": `${
                    $('[name="tag_product_id"]:checked').data().productTitle
                  }`,
                },
                sections: "cart-drawer",
              },
              success: function (response) {
                const html = new DOMParser().parseFromString(
                  response.sections["cart-drawer"],
                  "text/html"
                );
                document.querySelector("cart-quantity").updateHTML(html);
                document.dispatchEvent(new CustomEvent('theme:cartchanged'));
              },
              error: function (error) {
                console.log("sub product-not added");
              },
            });
          } else {
            // console.log(response);
            const html = new DOMParser().parseFromString(
              response.sections["cart-drawer"],
              "text/html"
            );
            document.querySelector("cart-quantity").updateHTML(html);
          }
        },
        error: function (error) {
          console.log("main product not added");
        },
      });
    }

    if ($(this).data().productHandle == "embroidery") {
      let prodId = parseInt($(this).data().productId);
      let activeHandle = $(".active_prod").data().productHandle;
      let customText = $('.cart_embroidery input[name="custom_embroidery_text"]').val().toUpperCase();
      if (customText.length < 1) {
        $(".cart_embroidery .error_custom_embro").removeClass("hidden");
        return;
      }
      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        dataType: "json",
        data: {
          quantity: 1,
          id: prodId,
          properties: {
            "Custom Embroidery Text": `${customText}`,
            "Custom Embroidery Text Color": `${$(
              `.embro_select_color[data-product-handle="${activeHandle}"] input:checked`
            ).val()}`,
            "Product Name": `${$(".active_prod").data().productTitle}`,
          },
          sections: "cart-drawer",
        },
        success: function (response) {
          // console.log("embrp", response);
          const html = new DOMParser().parseFromString(
            response.sections["cart-drawer"],
            "text/html"
          );
          document.querySelector("cart-quantity").updateHTML(html);
          document.dispatchEvent(new CustomEvent('theme:cartchanged'));
        },
        error: function (error) {
          console.log("embrp not added");
        },
      });
    }
    if ($(this).data().productHandle.includes("embossing")) {
      let prodId = parseInt($(this).data().productId);
      let activeHandle = $(".active_prod").data().productHandle;
      let customText = $('.cart_embossing input[name="custom_embossing_text"]').val().toUpperCase();
      if (customText.length < 1) {
        $(".cart_embossing .error_custom_embro").removeClass("hidden");
        return;
      }
      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        dataType: "json",
        data: {
          quantity: 1,
          id: prodId,
          properties: {
            "Custom Embossing Text": `${customText}`,
            "Product Name": `${$(".active_prod").data().productTitle}`,
          },
          sections: "cart-drawer",
        },
        success: function (response) {
          // console.log("embrp", response);
          const html = new DOMParser().parseFromString(
            response.sections["cart-drawer"],
            "text/html"
          );
          document.querySelector("cart-quantity").updateHTML(html);
          document.dispatchEvent(new CustomEvent('theme:cartchanged'));
        },
        error: function (error) {
          console.log("embrp not added");
        },
      });
    }
  });

  $(document).on("click", ".atc_upsell", function () {
    let prodId = $(this).data("productId");

    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      dataType: "json",
      data: {
        quantity: 1,
        id: prodId,
        sections: "cart-drawer",
      },
      success: function (response) {
        // ✅ Update cart drawer content
        const html = new DOMParser().parseFromString(
          response.sections["cart-drawer"],
          "text/html"
        );
        document.querySelector("cart-quantity").updateHTML(html);
        document.dispatchEvent(new CustomEvent('theme:cartchanged'));
      },
      error: function (error) {
        console.log("Product not added");
      },
    });
  });


  $('.siil_op li').click(function () {
    const giftAddId = $('[name="gift_oolor"]:checked').data().productVariantId;
    const colorVal = $('[name="gift_oolor"]:checked').val();
    $('.sow__selected_val').text(colorVal);
    $('.sel__img img').addClass('hidden');
    $(`[data-color="${colorVal}"]`).removeClass('hidden');
    $('.add_on_thres_limit').attr('data-add-id', giftAddId);
    console.log($('[name="gift_oolor"]:checked').data().productVariantId)
  });
  $('.add_on_thres_limit').click(function () {
    const prodId = $('.add_on_thres_limit').data().addId;
    $.ajax({
        type: "POST",
        url: "/cart/add.js",
        dataType: "json",
        data: {
          quantity: 1,
          id: prodId,
          sections: "cart-drawer",
        },
        success: function (response) {
          const html = new DOMParser().parseFromString(
            response.sections["cart-drawer"],
            "text/html"
          );
          cartDrawerUpdate();
          document.querySelector("cart-quantity").updateHTML(html);
          document.dispatchEvent(new CustomEvent('theme:cartchanged'));
        },
        error: function (error) {
          console.log("gift not added");
        },
      });
  });

}

// Run once on DOM ready
// $(document).ready(initCartDropdowns);

// Optional: rebind after AJAX/cart refresh if needed
document.addEventListener("theme:cartchanged", () => {
  setTimeout(initCartDropdowns, 100);
});
